<template>
  <div class="comp-main">
    <el-empty :image="image" :image-size="imageSize" :description="description">
      <slot />
    </el-empty>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: ''
    },
    imageSize: {
      type: Number,
      default: 60
    },
    description: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style lang="less" scoped>
.comp-main {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  /deep/ .el-empty__description {
    margin-top: 10px;
    p {
      font-size: 12px;
    }
  }
}
</style>
